export const hongKongPhotoInformation = {
  // central and western
  "central_hku_sign": {
    date: "2022-09-05",
    location: "HKU",
    description: ["Customary picture in front of school sign."]
  },
  "central_hku_view": {
    date: "2022-09-12",
    location: "HKU",
    description: ["View from the campus while walking between classes."]
  },
  "central_bbq_rice": {
    date: "2022-08-31",
    location: "Sai Ying Pun",
    description: ["Michelin Guide roast duck and char siu rice right outside the school."]
  },
  "central_fluffy_cat": {
    date: "2022-09-02",
    location: "Sai Ying Pun",
    description: ["Lots of store cats on Des Voeux Road. This one was particularly photogenic."]
  },
  "central_omakase": {
    date: "2022-10-08",
    location: "Sooshi Gold, Central",
    description: ["1 part of the omakase dinner."]
  },
  "central_neon_sign": {
    date: "2022-11-04",
    location: "Sai Ying Pun",
    description: ["A neon sign hanging at night."]
  },

  // kowloon city
  "kowloon_quarantine_meal": {
    date: "2022-08-22",
    location: "Quarantine Hotel",
    description: ["Typical quarantine meal."]
  },

  // tsuen wan
  "tsuen_gate": {
    date: "2022-10-26",
    location: "Western Monastery",
    description: ["Front gate of the Western Monastery. Interesting to visit after learning a bit more about the architecture behind buddhist temples in class."]
  },
  "tsuen_carp": {
    date: "2022-10-26",
    location: "Western Monastery",
    description: ["Carp pond."]
  },

  // sham shui po
  "sham_road": {
    date: "2022-10-14",
    location: "Outside Sham Shui Po Station",
    description: ["On route to Hop Yik Tai."]
  },

  // southern
  "southern_dragons_back_start": {
    date: "2022-10-22",
    location: "Northern End of Shek O",
    description: ["About to start Dragon's Back"]
  },
  "southern_sheko_beach": {
    date: "2022-10-22",
    location: "Shek O Country Park",
    description: ["View of Shek O Beach during the hike."]
  },
  "southern_take_picture": {
    date: "2022-10-22",
    location: "Shek O Country Park",
    description: ["What a nice day."]
  },
  "southern_beach_kids": {
    date: "2022-10-22",
    location: "Shek O Beach",
    description: ["Kids in matching outfits."]
  },

  // wan chai
  "wan_street": {
    date: "2022-10-30",
    location: "Wan Chai",
    description: ["Busy street."]
  },
  "wan_bbq_rice": {
    date: "2022-11-19",
    location: "Hay Hay Kitchen",
    description: ["Char siu rice — my most consumed meal."]
  },
  
  // yau tsim mong
  "yau_waterfront": {
    date: "2022-08-26",
    location: "Tsim Sha Tsui Promenade",
    description: ["I went for a run exactly once during the term and this was the view."]
  },
  "yau_stairs": {
    date: "2022-10-28",
    location: "King's Park",
    description: ["There are a bunch of paths like this everywhere, just endless stairs leading somewhere."]
  },
  "yau_park_track": {
    date: "2022-10-28",
    location: "King's Park",
    description: ["The stairs eventually led to a nice little park at the top of a hill."]
  },

  // islands
  "islands_before_cable": {
    date: "2022-11-09",
    location: "Tung Chung",
    description: ["Area before getting on the cable car."]
  },
  "islands_cable_car": {
    date: "2022-11-09",
    location: "Tung Chung",
    description: ["In the cable car to see the Big Buddha."]
  },
  "islands_big_buddha": {
    date: "2022-11-09",
    location: "Ngong Ping",
    description: ["We weren't allowed to walk up but yeah, that's a big buddha."]
  },
  "islands_wisdom_path": {
    date: "2022-11-09",
    location: "Wisdom Path, Ngong Ping",
    description: ["A short walk away, you can find the Wisdom Path."]
  },
  "islands_lantau_1": {
    date: "2022-11-26",
    location: "Lantau Peak Hike",
    description: ["Upon our return to hike Lantau Peak, the weather was not in our favour. This was the visibility for the entire hike."]
  },
  "islands_me": {
    date: "2022-11-26",
    location: "Lantau Peak Hike",
    description: ["Its-a me."]
  },
  "islands_lantau_2": {
    date: "2022-11-26",
    location: "Lantau Peak Hike",
    description: ["Another view."]
  },

  // eastern
  "eastern_wagyu": {
    date: "2022-11-12",
    location: "Japanese Wagyu Yakiniku Pure, Causeway Bay",
    description: ["Yakiniku for lunch."]
  },

  // tuen mun
  "tuen_chillwo": {
    date: "2022-11-13",
    location: "Chillwo (Shop name)",
    description: ["Tucked away in a random industrial looking complex is a Japanese thrift shop populated by 7 cats."]
  },
  "tuen_cats": {
    date: "2022-11-13",
    location: "Chillwo (Shop name)",
    description: ["Some of the cats."]
  },
  "tuen_reptile": {
    date: "2022-11-13",
    location: "Reptile House, Tuen Mun Park",
    description: ["Yup, that's a reptile."]
  },
  "tuen_sunset": {
    date: "2022-11-13",
    location: "Tuen Mun Park",
    description: ["Sunset from a park."]
  },

}